import { enumToArray } from '../../../../utils/enumToArray';
import { ShiftReportTooltip } from "./shiftReportTooltip";

const USER_GROUP_ID = {
    Driller: 7,
    DrillerAssistant: 9,
    ToolPusher: 11,
}

const requiredValuesForGroups = (discipline) => {
    return {
        [USER_GROUP_ID.Driller]: 1,
        [USER_GROUP_ID.DrillerAssistant]: discipline === 'Underground' ? 1 : 2,
        [USER_GROUP_ID.ToolPusher]: 1,
    }
}

const shiftReportTableColumns = (tableData, discipline) => {
    let tableColumns = [];

    if (tableData.rig === "Summary") {
        return tableData.table_header;
    } else {
        tableData.table_header.forEach((item) => {
            if (item.Header !== "Total" && item.Header !== "User Group") {
                tableColumns.push({
                    Header: item.Header,
                    accessor: item.accessor,
                    Cell: (cell) => {
                        const row = cell.row.original;

                        if (discipline === 'General Summary') {
                            return <div>{cell.value}</div>;
                        }

                        if (row.group_name === "Total") {
                            return (
                                <ShiftReportTooltip
                                    date={cell.column.id}
                                    rig={tableData.rig_id}
                                    shift={tableData.shift}
                                    value={cell.value}
                                />
                            );
                        } else if (enumToArray(USER_GROUP_ID).includes(row.group_id)) {
                            const requiredValues = requiredValuesForGroups(discipline);
                            return requiredValues[row.group_id] !== cell.value ? 
                                <div className='highlighted'>{cell.value}</div> : 
                                <div>{cell.value}</div>;
                        } else {
                            return <div>{cell.value}</div>;
                        }
                    },
                });
            } else {
                tableColumns.push({
                    Header: item.Header,
                    accessor: item.accessor,
                });
            }
        });
    }

    return tableColumns;
}

export default shiftReportTableColumns;
